module.exports = __webpack_public_path__ + "static/media/slider-6.ce921f7d.jpg";